var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutlinePowerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4u16y864na",
    d: "M15.24 3.54c.254-.492.858-.684 1.35-.43 4.098 2.117 6.217 6.764 5.127 11.246-1.09 4.483-5.104 7.638-9.717 7.638s-8.628-3.155-9.717-7.638C1.193 9.874 3.312 5.227 7.41 3.11c.318-.164.7-.147 1 .047.302.193.477.532.46.89-.016.357-.222.679-.54.843-3.28 1.693-4.975 5.41-4.104 8.997.871 3.586 4.083 6.112 7.774 6.112 3.69 0 6.903-2.526 7.774-6.112.871-3.587-.824-7.304-4.104-8.997-.492-.254-.684-.858-.43-1.35zM12 1c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1s-1-.448-1-1V2c0-.552.448-1 1-1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#ff4e4e",
    fillRule: "nonzero",
    xlinkHref: "#4u16y864na"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlinePowerRed);
export default __webpack_public_path__ + "static/media/icon-outline-power-red.7aa34613d14f5ecfa6d08a1159363c90.svg";
export { ForwardRef as ReactComponent };